const axios = require('axios');
export function LicenseListService()  {
    return axios.get("/license-generator/service/proxy.php", {
        headers: {
            'X-Proxy-URL': 'https://localhost:9443/getLicenses',
            'CONSOLE-ACCESS': true,
        }
    });
}
